import { useState, useEffect } from "react";
import { Spin } from "antd";
import { Link } from "react-router-dom";

import API from "scripts/api";
import Icons from "scripts/icons";
import Resources from "scripts/resources";

import Rocketman from "images/rocketman.png";
import GoldKey from "images/goldenkey.png";

const Component = () => {
	const initialState = {
		phoneNumbers: [],
	};
	const [state, setState] = useState(initialState);
	const { address, loaded, phoneNumbers } = state;

	const componentDidMount = () => {
		API.contact()
			.then(({ data }) => {
				setState((prevState) => ({
					...prevState,
					...data,
					loaded: true,
				}));
			})
			.catch();

		document.title = Resources.contactUs;
	};

	useEffect(componentDidMount, []);

	return loaded ? (
		<div className="page-contact">
			<div className="container">
				<img
					src={Rocketman}
					alt={Resources.contactUs}
					className="image"
				/>
				<h1 className="heading">
					<img
						src={GoldKey}
						alt={Resources.goldenKey}
					/>
					{Resources.contactUs}
				</h1>
				<div
					className="info"
					dangerouslySetInnerHTML={{ __html: address.replace(/\n/g, "<br />") }}
				/>
				{!!phoneNumbers.length && (
					<ul className="items">
						{phoneNumbers.map(({ number, type }, i) => (
							<li key={i}>
								<Link
									to={`tel:${number}`}
									target="_blank"
									rel="noopener noreferrer"
								>
									<Icons.Calling className="icon" />
									<span className="value">{number}</span>
									<span className="text">
										{type === "fax" ? Resources.faxUs : Resources.callUs}
									</span>
								</Link>
							</li>
						))}
					</ul>
				)}
			</div>
		</div>
	) : (
		<Spin className="page-loading" />
	);
};

export default Component;
